export default "__VITE_ASSET__DVCIth4q__"